"use client";

import React from "react";
import { Heading } from "@/components/ui/typography";

export default function Success({ heading = "Why Opening a Hong Kong Business Bank Account Is Hard for Foreign Founders" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black px-4 min-[1340px]:px-0 md:py-[60px] py-[30px]">
      <div className="flex flex-col lg:flex-row md:gap-8 gap-[24px] items-start max-w-[1200px] mx-auto">

        {/* LEFT CONTENT */}
        <div className="flex flex-col gap-6 lg:w-[584px] w-full">

          <div className="flex flex-col gap-6">
            <span className="text-[#ff6067] text-[24px] font-normal font-cambo">
              The Problem
            </span>

            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-white/70 text-[16px] leading-[160%] font-inter">
              Most founders assume forming the company is a difficult step. It isn’t. Opening the bank account is.
              <br />
              Traditional Hong Kong banks now apply strict approval filters, especially for remote-managed companies,
              newly incorporated entities, and foreign directors.
            </p>
          </div>

          {/* TAGS */}
          <div className="flex flex-col gap-2">

            <div className="border-l-2 border-[#ff6067] px-6 py-3">
              <p className="text-white text-[18px]">Hong Kong bank rejected my company application</p>
            </div>

            <div className="border-l-2 border-[#ff6067] px-6 py-3">
              <p className="text-white text-[18px]">why can&apos;t I open HK business bank account</p>
            </div>

            <div className="border-l-2 border-[#ff6067] px-6 py-3">
              <p className="text-white text-[18px]">HSBC rejecting HK company account foreigners</p>
            </div>

          </div>

          <p className="text-white/70 text-[16px] leading-[160%]">
            These are real issues, not rare cases.
          </p>

        </div>

        {/* RIGHT CONTENT */}
        <div className="flex flex-col gap-4 flex-1 w-full">

          <div className="bg-[#0f1218] border border-white/10 rounded-[16px] p-6 shadow-lg flex flex-col gap-6">

            <Heading as="h3" variant="cardTitleLight">
              Traditional banks often require
            </Heading>

            <div className="flex flex-col">

              {[
                "Local presence",
                "Local business activity",
                "In-person meetings",
                "Long compliance reviews",
                "Remote-managed company support",
                "Digital business recognition",
                "Foreign director acceptance",
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 py-3"
                >
                  <span className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center">
                    <span className="w-2.5 h-2.5 bg-[#ff6067] rounded-full"></span>
                  </span>
                  <p className="text-[12px] text-white">{item}</p>
                </div>
              ))}

            </div>

          </div>

          <p className="text-white/70 text-[14px] leading-[160%] font-medium">
            Without those, approval rates drop quickly. That’s why finding the right business banking solutions matters
            just as much as company formation itself.
          </p>

        </div>

      </div>
    </section>
  );
}